import { recordHotReload } from '../session';

let hotReloadPatched = false;

export function initHotReloadCollector(application: string, verbose = false) {
  if (
    typeof window === 'undefined' ||
    process.env.NODE_ENV !== 'development' ||
    hotReloadPatched
  ) {
    return;
  }

  hotReloadPatched = true;

  // eslint-disable-next-line no-console
  const originalLog = console.log;

  // eslint-disable-next-line no-console
  console.log = function (...args: any[]) {
    try {
      const msg = args.join(' ');
      const match = msg.match(/\[Fast Refresh\] done in (\d+)ms/);
      if (match && match[1]) {
        recordHotReload(application, parseInt(match[1], 10), verbose);
      }

      originalLog.apply(console, args);
    } catch (error) {
      originalLog.apply(console, args);
    }
  };
}

export function resetHotReloadCollector() {
  hotReloadPatched = false;
}
